import { type FunctionComponent, useMemo } from "react";
import { graphql, useLazyLoadQuery } from "react-relay";

import { BaseLinkContextProvider } from "shared/components/common/base-link/context";
import { article as articleData } from "shared/data";
import { notEmpty } from "shared/lib/utils";

import { usePlusArticlePopup } from "scmp-app/components/plus/article-popup/hooks";
import type { webinarWidgetQuery } from "scmp-app/queries/__generated__/webinarWidgetQuery.graphql";

import { Container, Item, ItemsList, StyledContentItemPlusWebinarWidget, Title } from "./styles";

type Props = {
  className?: string;
};

export const PlusCftWebinarWidget: FunctionComponent<Props> = ({ className }) => {
  const queryReference = useLazyLoadQuery<webinarWidgetQuery>(
    graphql`
      query webinarWidgetQuery($entityId: String!) {
        article(filter: { entityId: $entityId }) {
          seriesReverseOrder
          series {
            ... on Content {
              ...hooksPlusArticleLinkHandlerArticle
              ...plusWebinarWidgetContentItemContent
            }
          }
        }
      }
    `,
    {
      entityId: articleData.types.cftWebinar.entityId,
    },
    {
      fetchPolicy: "store-and-network",
    },
  );

  const { handleOpen } = usePlusArticlePopup();

  const items = useMemo(() => {
    const seriesReverseOrder = queryReference?.article?.seriesReverseOrder ?? false;
    const series = queryReference?.article?.series ?? [];
    const items = seriesReverseOrder ? [...series].toReversed() : series;
    return items.slice(0, 5);
  }, [queryReference?.article?.series, queryReference?.article?.seriesReverseOrder]);

  return (
    <BaseLinkContextProvider>
      <Container className={className}>
        <Title>LIVE Q&A WEBINARS</Title>
        <ItemsList>
          {items.map((item, index) => {
            if (!notEmpty(item)) return null;
            return (
              <Item key={index}>
                <StyledContentItemPlusWebinarWidget
                  onClick={() =>
                    handleOpen(item, {
                      pageType: "archive",
                    })
                  }
                  reference={item}
                />
              </Item>
            );
          })}
        </ItemsList>
      </Container>
    </BaseLinkContextProvider>
  );
};

PlusCftWebinarWidget.displayName = "PlusCftWebinarWidget";
